import { Description } from '@mui/icons-material'
import { GridActionsCellItem, type GridRowParams } from '@mui/x-data-grid'
import { useUser } from '@/features/auth/hooks/useUser'
import { setMediaDetailsState } from '@/features/media-details/slice'
import type { SearchResultItem } from '@/features/search/types'
import { useAppDispatch } from '@/redux/hooks'
import { CopyLinkAction } from './actions/CopyLinkAction'
import { DownloadAction } from './actions/DownloadAction'

export const ActionMenu = (params: GridRowParams) => {
  const dispatch = useAppDispatch()
  const user = useUser()
  const row: SearchResultItem = params.row

  let userActions = [
    <DownloadAction mediaCode={row.mediaCode} files={row.fileAttachments} />,
    <CopyLinkAction item={row} />,
    <GridActionsCellItem
      component="button"
      onClick={() => {
        dispatch(
          setMediaDetailsState({
            openDrawer: true,
            searchResultItem: row,
          }),
        )
      }}
      key="media-details"
      icon={<Description />}
      label="Media Details"
      title="Media Details"
    />,
  ]

  const adminActions: JSX.Element[] = []

  if (user.userRights.isAdmin) {
    userActions = [...userActions, ...adminActions]
  }

  return userActions
}
